
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { VuetifyMixin, AppHostnameMixin, PhysicalAssessmentMixin, AthleteRoutingMixin, StringsMixin, HelpInfoMixin, BAIconsMixin } from '@/mixins';
import { AthleteMetric, AthleteMetricValues } from '@/../types/enums';
import { SportName } from '@/../types';
import { AthleteProfileModel } from '@/models/athlete/AthleteProfileModel';
import { AthleteAssessmentDataModel } from '@/models/athlete/AthleteAssessmentDataModel';

import AthleteStatCard from './AthleteStatCard.vue';
import { SportModel } from '@/models';
import { sportStore } from '@/store';

@Component({
	components:{
		AthleteStatCard,
	}
})
export default class AthleteVerifiedAssessmentsCard extends Mixins(VuetifyMixin, AppHostnameMixin, PhysicalAssessmentMixin, AthleteRoutingMixin, StringsMixin, BAIconsMixin, HelpInfoMixin) {
	@Prop({ type: Boolean }) flat;
	@Prop({ required: true }) athlete: AthleteProfileModel;
	@Prop({ required: true }) assessmentData: AthleteAssessmentDataModel;
	@Prop({ type: Boolean }) buttons;
	@Prop({ type: Boolean }) extended;
	@Prop({ type: Boolean }) noTitle;
	@Prop({ type: Boolean }) hideIfNoShare;

	Soccer = SportName.Soccer;

	currentSport: SportModel;
	isSportLoaded: boolean = false;
	async mounted() {
		await this.loadSport();
	}
	async loadSport() {
		this.isSportLoaded = false;
		this.currentSport = await sportStore.findSportByName(this.assessmentData?.sport);
		if( this.IsEmpty(this.currentSport) ) this.currentSport = this.athlete.Sport;
		this.isSportLoaded = true;
	}
	get HasSport(): boolean {
		if( !this.isSportLoaded ) return false;
		return this.IsNotEmpty(this.currentSport);
	}

	get ShareAssessment(): boolean {
		if( !this.hideIfNoShare ) return true;
		return this.athlete?.profileVisibility?.recruiter?.physicalPerformance;
	}
	get HasAssessment(): boolean{
		return this.assessmentData !== null && this.assessmentData !== undefined;
	}
	
	compareData(): void{
		this.expandMetric(AthleteMetric.Acceleration);
	}

	expandMetric(metric: AthleteMetric): void{
		if( this.AthleteAppActive ) this.$emit('expandMetric', metric);
	}
	get AthleteMetrics(): AthleteMetric[]{
		return AthleteMetricValues;
	}
	get AssessmentData(): AthleteAssessmentDataModel | null{
		return this.assessmentData;
	}
	IsMetricReady(metric: AthleteMetric): boolean {
		switch(metric) {
			case AthleteMetric.Acceleration:
				return this.IsNotEmpty(this.assessmentData.tenMeterSprint);
			case AthleteMetric.Speed:
				return this.IsNotEmpty(this.assessmentData.twentyToThirtyFiveMeterSplit);
			case AthleteMetric.Agility:
				return this.IsNotEmpty(this.assessmentData.dropJumpHeight);
			case AthleteMetric.Power:
				return this.IsNotEmpty(this.assessmentData.counterMovementJumpHeight);
			case AthleteMetric.Recovery:
				return this.IsNotEmpty(this.assessmentData.yoyoIntermittentRecoveryTestStage);
		}
		return true;
	}
	get LastAssessedDate(): string {
		if(!this.assessmentData) return undefined;
		return this.formatDatePretty(this.assessmentData.assessmentDate, true);
	}
	assessmentLabel(assessment: string): string {
		if( this.IsEmpty(assessment) ) return ' ';

		if( assessment.toLowerCase().includes('t-drill') ) return 'Body Control';
		if( assessment.toLowerCase().includes('slalom') ) return 'Agility';
		if( assessment.toLowerCase().includes('illinois') ) return 'Agility';
		if( assessment.toLowerCase().includes('shot') ) return 'Power';

		if( assessment.toLowerCase().includes('accel') ) return '10M Sprint Time';
		if( assessment.toLowerCase().includes('speed') ) return '20-35M Split Time';
		if( assessment.toLowerCase().includes('agility') ) return 'Vertical Jump Height';
		if( assessment.toLowerCase().includes('power') ) return 'Counter Jump Height';
		if( assessment.toLowerCase().includes('recovery') ) return 'YoYo Test';

		if( assessment.toLowerCase().includes('10m') ) return 'Acceleration';
		if( assessment.toLowerCase().includes('20m') ) return 'Speed';
		if( assessment.toLowerCase().includes('35m') ) return 'Speed';
		if( assessment.toLowerCase().includes('counter') ) return 'Power';
		if( assessment.toLowerCase().includes('jump') ) return 'Agility';
		if( assessment.toLowerCase().includes('yoyo') ) return 'Recovery';

		return ' ';
	}
	assessmentUnits(assessment: string): string {
		if( this.IsEmpty(assessment) ) return '';

		if( assessment.toLowerCase().includes('t-drill') ) return 's';
		if( assessment.toLowerCase().includes('slalom') ) return 's';
		if( assessment.toLowerCase().includes('illinois') ) return 's';
		if( assessment.toLowerCase().includes('shot') ) return 'km/h';

		if( assessment.toLowerCase().includes('accel') ) return 's';
		if( assessment.toLowerCase().includes('speed') ) return 's';
		if( assessment.toLowerCase().includes('power') ) return 'cm';
		if( assessment.toLowerCase().includes('agility') ) return 'cm';
		if( assessment.toLowerCase().includes('recovery') ) return '';

		if( assessment.toLowerCase().includes('10m') ) return 's';
		if( assessment.toLowerCase().includes('20m') ) return 's';
		if( assessment.toLowerCase().includes('35m') ) return 's';
		if( assessment.toLowerCase().includes('counter') ) return 'cm';
		if( assessment.toLowerCase().includes('jump') ) return 'cm';
		if( assessment.toLowerCase().includes('yoyo') ) return '';

		return '';
	}
}
